module.exports = __webpack_public_path__ + "/bundle/asset/nsdua-logo-8c41dc6f2fc3c118a7576a12fd2aef38.png";